import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Ilustracja SVG (lekka i skalowalna) reprezentująca zagubioną ścieżkę
const LostPathIllustration = () => (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto max-w-xs mx-auto text-stone-300">
        <path d="M20,80 Q50,20 80,50" stroke="currentColor" fill="none" strokeWidth="3" strokeDasharray="5,5" />
        <path d="M25,70 Q40,90 60,75" stroke="currentColor" fill="none" strokeWidth="3" strokeDasharray="5,5" />
        <circle cx="20" cy="80" r="4" fill="#a07c5c" />
        <circle cx="80" cy="50" r="4" fill="#a07c5c" />
        <circle cx="60" cy="75" r="4" fill="#a07c5c" />
        <text x="45" y="65" fontFamily="monospace" fontSize="24" fill="#795b40">?</text>
    </svg>
);


const NotFound = () => {
    // Inicjalizacja AOS wewnątrz komponentu, jeśli nie jest globalna
    React.useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
        });
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-stone-50 px-4 py-12">
            <div
                className="w-full max-w-4xl grid md:grid-cols-2 gap-8 lg:gap-16 items-center"
                data-aos="fade-up"
                data-aos-delay="100"
            >
                {/* Kolumna lewa: Ilustracja */}
                <div data-aos="fade-right" data-aos-delay="300">
                    <LostPathIllustration />
                </div>

                {/* Kolumna prawa: Treść */}
                <div className="text-center md:text-left" data-aos="fade-left" data-aos-delay="500">
                    <p className="text-sm font-semibold text-[#a07c5c] uppercase tracking-widest">Błąd 404</p>

                    <h1 className="mt-4 text-4xl md:text-5xl font-extrabold text-gray-800 tracking-tight">
                        Ups! Chyba się zgubiłeś.
                    </h1>

                    <p className="mt-4 text-lg text-gray-600">
                        Strona, której szukasz, mogła zostać przeniesiona lub po prostu... zniknęła w cyfrowej dżungli.
                    </p>

                    <div className="mt-8">
                        <Link
                            to="/"
                            className="inline-flex items-center px-6 py-3 bg-[#a07c5c] text-white font-semibold rounded-lg shadow-md hover:bg-[#795b40] transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#a07c5c]"
                        >
                            <FaHome className="mr-2" /> Wróć na stronę główną
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;